import { FormattedMessage, useIntl } from 'react-intl';
import { EmptyState } from '@ets/design-system';

import styles from './TemplateEmptyState.module.scss';

const TemplateEmptyState = () => {
  const intl = useIntl();

  return (
    <div className={styles.root}>
      <EmptyState
        size="l"
        icon="folder"
        description={<FormattedMessage id="TENANT_DOESNT_HAVE_TEMPLATES_UPLOADED" />}
        title={intl.formatMessage({ id: 'NO_TEMPLATES' })}
        testId="no-templates"
      ></EmptyState>
    </div>
  );
};

export default TemplateEmptyState;
